import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Supplier } from '../models/supplier';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {

public actAddSupplier:boolean = true;

  constructor(private http:HttpClient) { }

  async getSuppliers() : Promise<Supplier[]>{
    return this.http.get<Supplier[]>('/api/supplier').toPromise();
  }

  getSupplier(id) : Promise<Supplier>{
    return this.http.get<Supplier>('/api/supplier/' + id).toPromise();
  }

  async postSupplier(supplier:Supplier) : Promise<Supplier> {
    return this.http.post<Supplier>('/api/supplier', supplier).toPromise();
  }

  async putSupplier(supplier:Supplier) : Promise<Supplier> {
    return this.http.post<Supplier>('/api/supplier/' + supplier.id + '/edit', supplier).toPromise();
  }

  async deleteSupplier(supplier:Supplier) : Promise<Supplier> {
    return this.http.get<Supplier>('/api/supplier/' + supplier.id + '/delete').toPromise();
  }


}
